//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            puzzles: [
                {
                    image: 'w2d5medtech.png',
                    x: 500,
                    y: 525,
                    width: 139,
                    height: 158,
                    correctDropAreaIndex: 1,
                    dropAreaIndex: -1
                },
                {
                    image: 'w2d5roboter.png',
                    x: 685,
                    y: 540,
                    width: 182,
                    height: 134,
                    correctDropAreaIndex: 2,
                    dropAreaIndex: -1
                },
                {
                    image: 'w2d5surgeon.png',
                    x: 920,
                    y: 515,
                    width: 118,
                    height: 176,
                    correctDropAreaIndex: 0,
                    dropAreaIndex: -1
                }
            ],
            dropAreas: [
                {
                    xMin: 402,
                    xMax: 604,
                    yMin: 185,
                    yMax: 513
                },
                {
                    xMin: 627,
                    xMax: 831,
                    yMin: 185,
                    yMax: 513
                },
                {
                    xMin: 848,
                    xMax: 1053,
                    yMin: 185,
                    yMax: 513
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.correctDropAreaIndex === puzzle.dropAreaIndex).length;

            return this.$game.getDragDropResult(numCorrect, this.puzzles.length - numCorrect);
        }
    },

    methods: {
        dragend (puzzle, { x, y }) {
            this.showHoverBg = false;

            puzzle.x = x;
            puzzle.y = y;
            puzzle.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                puzzle.x >= area.xMin - puzzle.width / 2 &&
                puzzle.x <= area.xMax - puzzle.width / 2 &&
                puzzle.y >= area.yMin - puzzle.height / 2 &&
                puzzle.y <= area.yMax - puzzle.height / 2
            );

            if (puzzle.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    puzzle.x = this.dropAreas[puzzle.dropAreaIndex].xMin + 100 - puzzle.width / 2;
                    puzzle.y = 290;
                });
            }
        }
    }
};
